export const UNKNOWN = 'UNKNOWN';

export const HTTP_UNAUTHORIZED_ERRORCODE = 401;

export const HMI_USER_HEADER_NAME = 'hmi_user';
export const HMI_USER_HEADER_VALUE = 'true';
